import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../_services/shared.service';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { OfferService } from '../../_services/offer/offer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StatusDTO } from '../../model/statusDTO';
import { Observable, catchError, ignoreElements, map, of, shareReplay } from 'rxjs';
import { BusyService } from '../../_services/busy.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { OfferStatus } from '../../enum/offerStatus';
import {MatTableModule} from '@angular/material/table';
import { ConfirmationDTO } from '../../model/confirmationDTO';
import { ShoppingCartTableComponent } from '../shopping-cart-table/shopping-cart-table.component';
import { ThemeService } from '../../_services/theme.service';


export interface OfferStatusElement {
  name: string;
  value: string;
}

@Component({
    selector: 'app-offer-status',
    standalone: true,
    imports: [CommonModule,
        MatCardModule,
        ShoppingCartTableComponent,
        NgxSpinnerModule],
    templateUrl: './offer-status.component.html',
    styleUrl: './offer-status.component.scss'
})
export class OfferStatusComponent implements OnInit {

  public propertyId: string = '';
  public offerAliasId: string = '';
  private offerSetId: string = '';
  public offerStatus$!: Observable<OfferStatusElement[]>;
  public offerConfirmation$!: Observable<OfferStatusElement[]>;
  public offerConfirmationNew$!: Observable<any[]>;
  public offerStatusDTO!: StatusDTO;
  public offerErrors$: any;
  private isError: boolean = false;

  public displayedColumns: string[] = ['name', 'value'];
  public offerStatusData: OfferStatusElement[] = [];
  public offerStatusMessage: string = '';
  public offerStatus: string = '';
  public OfferStatus = OfferStatus;
  public themeReady: boolean = false;

  constructor(public sharedService: SharedService,
              private offerService: OfferService,
              private route: ActivatedRoute,
              private router: Router,
              private busyService: BusyService,
              public themeService: ThemeService) { 
  }

  /** Standalone instance — avoids injecting CurrencyPipe which requires a provider registration. */
  private cp = new CurrencyPipe('en-US');

  public offerStatusTable: OfferStatusElement[] = [];

  ngOnInit(): void {

    this.offerStatusData = [];
    this.propertyId = this.route.snapshot.paramMap.get('prop_id') ? this.route.snapshot.paramMap.get('prop_id') as string : '';
    this.offerAliasId = this.route.snapshot.paramMap.get('alias_id') ? this.route.snapshot.paramMap.get('alias_id') as string : '';
    this.offerSetId = this.route.snapshot.paramMap.get('offer_set_id') ? this.route.snapshot.paramMap.get('offer_set_id') as string : '';

    this.waitForThemeReady();

    // Restore persisted browser theme/mode through the theme service.
    const prestayTheme = this.sharedService.applicationConfig?.prestay?.theme;
    this.themeService.restorePersistedThemeOrApply(prestayTheme, 'zen').finally(() => {
      this.themeReady = this.themeService.isThemeReady();
    });

    this.offerConfirmationNew$ = this.getConfrimationInfoNew(this.offerAliasId, this.propertyId);
                                        
    this.offerErrors$ = this.offerConfirmationNew$.pipe(
      shareReplay(1),
      ignoreElements(),
      catchError((err) => {
        return of(err)
      })
    );


    // this.offerConfirmation$ = this.getConfrimationInfo(this.offerAliasId, this.propertyId, this.offerStatusData);                                      
   // let offerStatus$ = this.getOfferStatus(this.offerAliasId, this.propertyId, this.offerStatusData);

    // this.offerStatus$ = concat(offerStatus$, this.offerConfirmation$)
    //   .pipe(
    //     shareReplay()
    //     ,takeLast(1)
    //     , map(res => {
    //       this.offerStatusData = res;
    //       return this.offerStatusData;
    //     })

    //   );

    // this.offerErrors$ = this.offerStatus$.pipe(
    //                                       shareReplay(1),
    //                                       ignoreElements(),
    //                                       catchError((err) => {
    //                                         return of(err)})
    //                                     );
        

  }

  private waitForThemeReady(): void {
    this.themeReady = this.themeService.isThemeReady();

    if (this.themeReady) {
      return;
    }

    this.themeService.themeReady$.subscribe(isReady => {
      this.themeReady = isReady;
    });
  }
  
  getOfferStatus(offerAliasId: string, propertyId: string, offerStatusData: OfferStatusElement[]): Observable<OfferStatusElement[]> {
    return this.offerStatus$ = this.offerService.getOfferStatus(offerAliasId, propertyId)
      .pipe(
        shareReplay(1),
        map(res => {
          this.offerStatusMessage = this.getStatusMessage(res.upgrade_status);
          this.offerStatus = res.upgrade_status;
          
          offerStatusData.push({name: 'Upgrade Offer Status:', value: res.upgrade_status});
          offerStatusData.push({name: 'Conf Number:', value: res.conf_num});                        
          return offerStatusData;
        })
      );
  }

  getConfrimationInfo(offerAliasId: string, propertyId: string, offerStatusData: OfferStatusElement[]): Observable<OfferStatusElement[]> {
    return this.offerConfirmation$ = this.offerService.getConfrimationInfo(offerAliasId, propertyId)
      .pipe(
          shareReplay(1),
          map(res => {
            res.map((conf: ConfirmationDTO) => {

              let upgradeType: string = 'New Room Type:';
              if(conf.effective_freq !== 'DAILY'){
                upgradeType = 'Add On:';
              }
              offerStatusData.unshift({name: 'Property:', value: conf.prop_name});
              offerStatusData.push({name: upgradeType, value: conf.room_category_name});
              offerStatusData.push({name: 'Nightly Upgrade Rate:', value: this.cp.transform(conf.ofr_price, 'USD', 'symbol', '1.2-2') as string});
              offerStatusData.push({name: 'Total Upgrade Charge:', value: this.cp.transform(conf.ofr_total_price, 'USD', 'symbol', '1.2-2') as string});
            });
            return offerStatusData;             
          })
        );
  }


  getConfrimationInfoNew(offerAliasId: string, propertyId: string): Observable<any[]> {
    return this.offerService.getConfrimationInfo(offerAliasId, propertyId)
      .pipe(
          shareReplay(1),
          map(res => {
            let res_out: any[] = [...res];
            return res_out;
          })
        );
  }



  getStatusMessage(offerStatus: string){
    
    let accepted = OfferStatus.ACCEPTED as string;
    let pending = OfferStatus.PENDING as string;
    let rejected = OfferStatus.REJECTED as string;

    var responseTexts: { [id: string] : string; } = {};

    responseTexts[accepted] = 'Your request was Accepted.';
    responseTexts[pending] = 'Your request is still processing. Please check back later.';
    responseTexts[rejected] = 'Apologies, your request could not be fulfilled. Feel free to ask about upgrades upon checkin.';        

    let key = offerStatus as keyof typeof responseTexts;

    return responseTexts[key];
  }
}



